/** 任务状态说明
 * @param {analysisRunningStatus} 20 分析中 25 等待分析
 * @param {analysisEndStatus} 0 等待提交 5 分析完成(有警告) 10 分析完成(有错误) 15 分析失败
 *****                        30 提交渲染失败 35 已自动提交 40 已提交 45 放弃 48 超时停止
 * @param {preRenderStatus} 0 等待中 8 预处中 10 已停止 23超时停止 25 已完成 45 失败
 * @param {renderRunningStatus} 0 等待中 5 渲染中
 * @param {renderEndStatus} 10 已停止 20 欠费停止 25 已完成 30 已完成有失败帧 35 放弃 40 测试完成 45 失败
 */

export const analysisStatus = Object.freeze({
  waitingSubmit: 0,
  finishedWarning: 5,
  finishedError: 10,
  finishedFail: 15,
  analyzing: 20,
  waitingAnalysis: 25,
  submitFail: 30,
  submitAuto: 35,
  submited: 40,
  abandon: 45,
  timeoutStop: 48,
})
export const analysisRunningStatus = [
  analysisStatus.analyzing,
  analysisStatus.waitingAnalysis,
]
export const analysisEndStatus = [
  analysisStatus.waitingSubmit,
  analysisStatus.finishedWarning,
  analysisStatus.finishedError,
  analysisStatus.finishedFail,
  analysisStatus.submitFail,
  analysisStatus.submitAuto,
  analysisStatus.submited,
  analysisStatus.abandon,
  analysisStatus.timeoutStop,
]

export const renderStatus = Object.freeze({
  waiting: 0,
  rendering: 5,
  preRendering: 8,
  stop: 10,
  arrearageStop: 20,
  timeoutStop: 23,
  finished: 25,
  finishedHasFailed: 30,
  abandon: 35,
  finishedTest: 40,
  failed: 45,
  analyse: 50,
  updating: 100,
  renderingTaskSubmitting: 60,
  renderTaskSumbitFail: 65,
  finishedHasStopped: 70,
})
export const preRenderStatus = [
  renderStatus.waiting,
  renderStatus.preRendering,
  renderStatus.stop,
  renderStatus.timeoutStop,
  renderStatus.finished,
  renderStatus.failed,
]
export const renderRunningStatus = [
  renderStatus.waiting,
  renderStatus.rendering,
]
export const renderEndStatus = [
  renderStatus.stop,
  renderStatus.arrearageStop,
  renderStatus.timeoutStop,
  renderStatus.finished,
  renderStatus.finishedHasFailed,
  renderStatus.abandon,
  renderStatus.finishedTest,
  renderStatus.failed,
  renderStatus.finishedHasStopped,
]

// // 分析
// TASK_ANALYSE("Analyze"),
// // 预处理
// TASK_PREPARE("Pre"),
// // 光子
// TASK_RENDER_PHOTON("RenderPhoton"),
// // 合并光子
// TASK_MERGE_PHOTON("MergePhoton"),
// // 优先渲染任务
// TASK_PRIORITY_RENDER("PreRender"),
// // 普通渲染任务
// TASK_RENDER("Render"),
// // houdini的结算
// TASK_GOP_NODE("GopRender"),
// // houdini 分布式解算
// TASK_DISTRIBUTED_NODE("DistributedRender"),
// // 效果图
// TASK_PICTURE("picture");
// ContextCapture空三任务（有空三的任务，空三流程和重建流程一起节约时间）
// TASK_TRIANGULATION("Triangulation"),
// //ContextCapture重建任务
// TASK_REBUILD("Rebuild"),
// TASK_3DTILES("3DTiles");
export const TaskType = Object.freeze({
  Analyze: 'Analyze',
  Pre: 'Pre',
  RenderPhoton: 'RenderPhoton',
  MergePhoton: 'MergePhoton',
  PreRender: 'PreRender',
  Render: 'Render',
  GopRender: 'GopRender',
  DistributedRender: 'DistributedRender',
  picture: 'picture',
  Shell: 'Shell',
  Triangulation: 'Triangulation',
  Rebuild: 'Rebuild',
  _3DTiles: '3DTiles',
  Tiff: 'TIFF',
})

export const productStatus = Object.freeze({
  Waiting: 0,
  Producting: 5,
  Stopped: 10,
  Succeed: 25,
  Fail: 45,
  FailTotalBlock: 30,
  arrearStop: 20,
  timeout: 23,
})

export const stopFrameStatus = Object.freeze({
  all: 0,
  user: 1,
  admin: 2,
  arrears: 3,
})

export const productRunningStatus = [
  productStatus.Waiting,
  productStatus.Producting,
]

export const productEndTaskStatus = [
  productStatus.Stopped,
  productStatus.Succeed,
  productStatus.Fail,
  productStatus.FailTotalBlock,
  productStatus.arrearStop,
  productStatus.timeout,
]

export const sky3Status = Object.freeze({
  emptyThreeWaitingSubmit: 60,
  emptyThreeWaiting: 0,
  emptyThreeing: 5,
  stopped: 10,
  arrearStop: 20,
  timeout: 23,
  succeeded: 25,
  FailTotalBlock: 30,
  failed: 45,
  emptyThreeCalculating: 50,
})

export const sky3EndStatus = [
  sky3Status.succeeded,
  sky3Status.failed,
  sky3Status.stopped,
  sky3Status.FailTotalBlock,
  sky3Status.arrearStop,
  sky3Status.timeout,
]

export const sky3RunningStatus = [
  sky3Status.emptyThreeWaitingSubmit,
  sky3Status.emptyThreeWaiting,
  sky3Status.emptyThreeing,
]

export const rebuildStatus = Object.freeze({
  rebuilding: 5,
  waitingRebuild: 0,
  waitingSubmitRebuild: 60,
  timeout: 23,
  rebuildEndSubmit: 25,
  rebuildFail: 45,
  rebuildStop: 10,
})

export const rebuildRunningStatus = [
  rebuildStatus.rebuilding,
  rebuildStatus.waitingRebuild,
  rebuildStatus.waitingSubmitRebuild,
]

export const rebuildEndStatus = [
  rebuildStatus.rebuildEndSubmit,
  rebuildStatus.rebuildFail,
  rebuildStatus.rebuildStop,
  rebuildStatus.timeout,
]

export const publishStatus = Object.freeze({
  Complete: 0,
  CompleteHaveWarn: 5,
  CompleteHaveError: 10,
  Fail: 15,
  Publishing: 20,
  Waiting: 25,
  SubmitFail: 30,
  AutoCommot: 35,
  Submitted: 40,
  Abanndon: 45,
  TimeOut: 48,
})
